/**
 * Main Entry Point for Motion Bundle
 * Bundled with esbuild via Node.js
 */

import { initHeroCanvas } from './hero-canvas.js';
import { initGSAPAnimations } from './scroll-animations.js';

function start() {
    initHeroCanvas();
    initGSAPAnimations();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
} else {
    start();
}
